import { Reveal } from "@/components/site/Reveal";
import { IMAGES } from "@/site";
import { Sofa, Warehouse, Trees, Briefcase } from "lucide-react";

const CARDS = [
  {
    id: "living-room",
    tag: "01 / In-Home",
    title: "The Living Room Rug",
    desc: "No equipment, no problem. I bring everything we need and turn the space you already have into your personal studio.",
    img: IMAGES.home,
    icon: Sofa,
    span: "md:col-span-7",
  },
  {
    id: "garage-gym",
    tag: "02 / Garage",
    title: "Wake The Sleeping Gym",
    desc: "Got kit gathering dust in the garage or cupboard? Let's wake it up and train exactly like a full gym.",
    img: IMAGES.garage,
    icon: Warehouse,
    span: "md:col-span-5",
  },
  {
    id: "park",
    tag: "03 / Outdoors",
    title: "Park & Back Garden",
    desc: "The freedom of the open air. Fresh, adaptable sessions in your garden or a local Essex park.",
    img: IMAGES.park,
    icon: Trees,
    span: "md:col-span-5",
  },
  {
    id: "workplace",
    tag: "04 / Workplace",
    title: "At The Workplace",
    desc: "Short on time and working from the office? I come to you and fit training around your day.",
    img: IMAGES.workplace,
    icon: Briefcase,
    span: "md:col-span-7",
  },
];

export const Services = () => (
  <section id="services" className="py-24 md:py-32 bg-[#020617]">
    <div className="mx-auto max-w-7xl px-5 md:px-10">
      <Reveal>
        <span className="font-mono-label text-[11px] text-[#FACC15]">What I do</span>
        <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl mt-4 max-w-3xl">
          One trainer. <span className="text-[#FACC15]">Any space</span> you've got.
        </h2>
        <p className="text-[#94A3B8] max-w-xl mt-5 text-base md:text-lg">
          Whether you want to <span className="text-[#F8FAFC]">lose weight</span>, <span className="text-[#F8FAFC]">build muscle</span>, <span className="text-[#F8FAFC]">get fit</span> or simply <span className="text-[#F8FAFC]">get healthy</span> — I don't belong to any gym, I bring the gym to you. Every session is designed around your level, your goals and the space available.
        </p>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-5 md:gap-6 mt-14">
        {CARDS.map((c, i) => {
          const Icon = c.icon;
          return (
            <Reveal key={c.id} delay={i * 0.08} className={c.span}>
              <div
                data-testid={`service-card-${c.id}`}
                className="group relative h-72 md:h-96 rounded-3xl overflow-hidden border border-white/10"
              >
                <img src={c.img} alt={c.title} className="img-desat absolute inset-0 w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#020617] via-[#020617]/50 to-[#020617]/10" />
                <div className="relative h-full flex flex-col justify-between p-6 md:p-8">
                  <div className="flex items-center justify-between">
                    <span className="font-mono-label text-[10px] text-[#FACC15]">{c.tag}</span>
                    <Icon size={22} className="text-[#F8FAFC]/70" />
                  </div>
                  <div>
                    <h3 className="font-display font-bold text-2xl md:text-3xl">{c.title}</h3>
                    <p className="text-[#94A3B8] text-sm md:text-base mt-2 max-w-md">{c.desc}</p>
                  </div>
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
